import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { FaPlus, FaMinus, FaEdit, FaTrash, FaUsers } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from "@mui/icons-material/Add";
import bookmark from "../../assets/img/3.png";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Avatar from "@mui/material/Avatar";
import Fab from "@mui/material/Fab";
import $ from "jquery";
import axios from "axios";
import RefreshIcon from "@mui/icons-material/Refresh";
import Select from "react-select";
import HighLighter from "../layout/HighLighter";
const TagPeople = [
  { value: "Everyone", label: "Everyone" },
  { value: "Users", label: "Users" },
];

const userlistDataEmpty = [{ value: "Please wait..", label: "Please wait.." }];

const FAQData = [
  {
    question: "What is the weather like today?",
    answer:
      "I'm sorry, I cannot provide real-time weather information. Please check a weather website or app for the current weather.",
  },
  {
    question: "How do I reset my password?",
    answer:
      "To reset your password, go to the 'Forgot Password' page on our website and follow the instructions provided. You'll receive an email with a link to reset your password.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept various payment methods, including credit cards, PayPal, and bank transfers. You can find a list of accepted payment methods on our website during the checkout process.",
  },
  {
    question: "How do I return a product?",
    answer:
      "To return a product, log in to your account, go to the 'Order History' section, and follow the instructions for initiating a return. Make sure to check our return policy for eligibility and further details.",
  },
  {
    question: "Do you offer international shipping ?",
    answer:
      "Yes, we offer international shipping to many countries. Shipping fees and delivery times may vary depending on your location. You can check the available shipping options during the checkout process.",
  },
];
const SlidingPanel = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openReply, setopenReply] = useState(false);
  const [openEditReply, setopenEditReply] = useState(false);
  const [openEditPost, setopenEditPost] = useState(false);

  const [userInfo, setUserInfo] = useState(null);
  const [name, setName] = useState("");
  const [postView, setPostView] = useState({});
  const [commentVisibility, setCommentVisibility] = useState({});
  const [PostTopicMessage, setPostTopicMessage] = useState("");
  const [PostTopicReplayMessage, setPostTopicReplayMessage] = useState("");
  const [PostTopicEditMessage, setPostTopicEditMessage] = useState("");
  const [ReplyTopicEditMessage, setReplyTopicEditMessage] = useState("");

  const [parentId, setparentId] = useState();
  const [topicid, settopicid] = useState();
  const [EditPostId, setEditPostId] = useState();
  const [EditPostReplyId, setEditPostReplyId] = useState();
  const [DeleteConfirm, setDeleteConfirm] = useState(false);
  const [DeleteId, setDeleteId] = useState();
  const [LoadingReplay, setLoadingReplay] = useState(false);
  const [tabValue, setTabValue] = useState("tab1"); // Initialize with 'tab1' as the default tab
  const [isrefreshing, setisrefreshing] = useState(false);
  const [UserTypeComments, setUserTypeComments] = useState(TagPeople[0]); // Set the default value to the first option
  const inputRef = useRef();
  const [pdfPreviews, setPdfPreviews] = useState([]);
  const [docPreviews, setDocPreviews] = useState([]);
  const [openState, setOpenState] = useState(Array(FAQData.length).fill(false));
  const [FaqsList, setFaqsList] = useState([]);
  const [selectedTagUsers, setselectedTagUsers] = useState([]);
  const [TagUsersData, setTagUsersData] = useState([]);
  const [userlistData, setuserlistData] = useState([]);
  const [userlistDataLoading, setuserlistDataLoading] = useState(true);

  const handleClickOpen = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
    setImagePreviews([]);
    setselectedTagUsers([]);
    setUserTypeComments(TagPeople[0]);
    setPostTopicMessage("");
    setTagUsersData([]);
  };

  const handleCloseReplay = () => {
    setopenReply(false);
    setPostTopicReplayMessage("");
  };

  const handleClosePostEdit = () => {
    setopenEditPost(false);
    setPostTopicEditMessage("");
  };

  const handleCloseReplyEdit = () => {
    setopenEditReply(false);
    setReplyTopicEditMessage("");
  };
  const passtoken = !localStorage.getItem("access-token-storage") ||
    localStorage.getItem("access-token-storage") === null
      ? null
      : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [postComments, setPostComments] = useState([]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const email = localStorage.getItem("myemail");
  const typeofuser = localStorage.getItem("userType");

  const baseurl = `${process.env.REACT_APP_SERVER_URL}/aipd/posts/v2/${props.guid}`;
  const baseurlFaqs = `${process.env.REACT_APP_SERVER_URL}/aipd/getFaq/reportId/${props.reportId}`;
  const baseurlUserList = `${process.env.REACT_APP_SERVER_URL}/aipd/userEmailsByUserGroupId`;

  useEffect(() => {
    GetuserLists();
    if (props.guid !== undefined) {
      GetFaqsLsit();
      GetSaveReports();
      viewNotificationsReply();
    }
  }, []);

  const GetSaveReports = async () => {
    setisrefreshing(true);
    try {
      const response = await fetch(baseurl, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        const postData = jsonData.data.posts;
        const newArray = postData.filter((item) => item !== null);

        setPostComments(newArray);
        setisrefreshing(false);
      } else {
        setPostComments([]);
        setisrefreshing(false);
      }
    } catch (err) {
      console.error("Error:", err);
      setPostComments([]);
      setisrefreshing(false);
    }
  };

  const GetuserLists = async () => {
    try {
      const response = await fetch(baseurlUserList, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        const postData = jsonData;

        setuserlistData(postData);
        setuserlistDataLoading(false);
      } else {
        setuserlistData([]);
        setuserlistDataLoading(false);
      }
    } catch (err) {
      console.error("Error:", err);
      setuserlistData([]);
      setuserlistDataLoading(false);
    }
  };

  const GetFaqsLsit = async () => {
    try {
      const response = await fetch(baseurlFaqs, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        setFaqsList(jsonData);
      } else {
        setFaqsList([]);
      }
    } catch (err) {
      console.error("Error:", err);
      setFaqsList([]);
    }
  };

  function formatDate(date) {
    const dateObj = new Date(date);

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      dateObj
    );
    return formattedDate;
  }

  // const ViewMainPostReply = (id) => {
  //   $(`#postDataid_${id}`).slideToggle(350)
  // }

  // const ViewMainPostReply = (id) => {
  //   setPostView((prevPostView) => ({
  //     ...prevPostView,
  //     [id]: !prevPostView[id],
  //   }));
  // };

  const viewNotificationsReply = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const notificationID = searchParams.get("notificationiD");
    // console.log(notificationID); // This will log the value of 'notificationiD' parameter

    if (notificationID !== null || notificationID !== undefined) {
      setPostView((prevPostView) => ({
        ...prevPostView,
        [notificationID]: !prevPostView[notificationID],
      }));

      const toggleElement = document.getElementById(
        `postDataid_${notificationID}`
      );
      // console.log(toggleElement)
      if (toggleElement) {
        $(toggleElement).slideToggle(350);
        const toggleElement_new = document.getElementById(
          `Level_1_postDataid_${notificationID}`
        );
        if (toggleElement_new) {
          // console.log(toggleElement_new); // You can change console.log to alert if you want to display in an alert box
          var firstChild = toggleElement_new.firstElementChild;
          var idParts = firstChild.id.split("-");
          var number = idParts[idParts.length - 1];
          // console.log(number); // You can change console.log to alert if you want to display in an alert box
          setCommentVisibility((prevVisibility) => ({
            ...prevVisibility,
            [number]: !prevVisibility[number],
          }));

          setPostView((prevPostView) => ({
            ...prevPostView,
            [notificationID]: !prevPostView[notificationID],
          }));
        }
      }

      setCommentVisibility((prevVisibility) => ({
        ...prevVisibility,
        [notificationID]: !prevVisibility[commentId],
      }));
    }
  };

  useEffect(() => {
    viewNotificationsReply();
  }, [isrefreshing]);

  const ViewMainPostReply = (id) => {
    // Use ref to access the DOM element with the specific ID
    setPostView((prevPostView) => ({
      ...prevPostView,
      [id]: !prevPostView[id],
    }));
    const toggleElement = document.getElementById(`postDataid_${id}`);
    if (toggleElement) {
      $(toggleElement).slideToggle(350);
    }
  };

  const toggleReplyVisibility = (commentId) => {
    setCommentVisibility((prevVisibility) => ({
      ...prevVisibility,
      [commentId]: !prevVisibility[commentId],
    }));

    console.log(commentVisibility);
  };

  // console.log(postView)

  // console.log(postView);

  // const ViewReply = (id) => {
  //   $(`#nested-reply-${id}`).slideToggle(350);
  // };

  const repliesComment = (id, name, topic) => {
    setName(name);
    settopicid(topic);
    setparentId(id);
    setopenReply(true);
  };

  const togglePanel = () => {
    alert();
    setIsOpen(!isOpen);
  };

  const RenderReplies = ({ replies, id, depth = 2 }) => {
    if (!replies || replies.length === 0) {
      return null;
    }

    const topLevelReplies = replies;
    // const topLevelReplies = replies.slice(0, 100);

    // const remainingReplies = replies.slice(depth);

    return (
      <>
        <div
          id={`Level_1_${id}`}
          style={{
            paddingLeft: "2.4rem",
            width: "100%",
            paddingTop: "1rem",
            display: "grid",
            gridGap: "1rem",
          }}
        >
          {topLevelReplies.map((reply, replyindex) => {
            return (
              <div
                id={`Level-${replyindex}_reply-${reply.commentId}`} // Add a unique id for each reply
                key={replyindex}
                style={{
                  display: "grid",
                  alignItems: "flex-start",
                  alignContent: "flex-start",
                  gridGap: "10px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gridGap: "10px",
                    alignItems: "flex-start",
                    alignContent: "flex-start",
                  }}
                >
                  <Avatar
                    style={{
                      width: "30px",
                      height: "30px",
                      fontSize: "10px",
                      textTransform: "uppercase",
                    }}
                  >
                    {reply.author.charAt(0)}
                  </Avatar>
                  <div style={{ display: "grid", width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#253978",
                          textTransform: "capitalize",
                        }}
                      >
                        {findUsernameFromGmail(reply.author)}
                      </span>

                      {reply.author === email && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gridGap: "20px",
                          }}
                        >
                          <FaEdit
                            onClick={(e) =>
                              EditPostReplayTopic(reply.commentId, reply.text)
                            }
                            style={{
                              color: "#253978",
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                          />

                          <FaTrash
                            onClick={(e) => DeletePoup(reply.commentId)}
                            style={{
                              color: "#dc3545",
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    <span
                      style={{
                        fontSize: "14px",
                        color: "#253978",
                        fontWeight: "500",
                      }}
                    >
                      {reply.text}
                    </span>

                    <span
                      style={{
                        fontSize: "12px",
                        paddingTop: "5px",
                        color: "#253978",
                      }}
                    >
                      Posted on: {formatDate(reply.createdDateTime)}
                    </span>

                    <>
                      {depth !== 0 && ( // Check if depth is less than 3 - 1 (maxDepth)
                        <div
                          style={{
                            display: "flex",
                            gridGap: "1rem",
                            paddingTop: "1rem",
                            color: "#253978",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={(e) =>
                              repliesComment(
                                reply.commentId,
                                reply.author,
                                reply.topicId
                              )
                            }
                          >
                            Reply
                          </span>

                          {reply.replies.length !== 0 && (
                            <span
                              className="replyPost"
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                toggleReplyVisibility(reply.commentId)
                              }
                            >
                              {commentVisibility[reply.commentId]
                                ? "Hide"
                                : `Comments (${reply.replies.length})`}
                            </span>
                          )}
                        </div>
                      )}
                    </>
                  </div>
                </div>

                {/* Recursively render nested replies */}
                {/* <RenderReplies id={`nested-reply-${reply.commentId}`} replies={reply.replies} depth={depth - 1}/> */}

                {commentVisibility[reply.commentId] && (
                  <RenderReplies
                    id={`nested-reply-${reply.commentId}`}
                    replies={reply.replies}
                    depth={depth - 1}
                  />
                )}
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const PostTopic = () => {
    if (PostTopicMessage === "") return false;

    setLoadingReplay(true);
    const email = localStorage.getItem("myemail");
    // console.log("Tag People")
    // console.log(UserTypeComments)
    const data = {
      topicIdentifier: props.guid,
      email: email,
      reportId: props.reportId,
      subject: PostTopicMessage,
      accessEmails:
        JSON.stringify(TagUsersData) === JSON.stringify([]) ? [] : TagUsersData,
      notifierEmails:
        JSON.stringify(TagUsersData) === JSON.stringify([])
          ? ["Everyone"]
          : TagUsersData,
      type:
        JSON.stringify(TagUsersData) === JSON.stringify([]) ? "NORMAL" : "RES",
      pageName: props.pageName,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/createTopic/v2`;
    // const url = `https://localhost:5000/aipd/createTopic`;

    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          GetSaveReports();
          setLoadingReplay(false);
          setOpen(false);
          setPostTopicMessage("");
          setselectedTagUsers([]);
          setTagUsersData([]);
          setUserTypeComments(TagPeople[0]);
        }
      })
      .catch(function (error) {
        setLoadingReplay(false);
        alert("Error");
      });
  };

  // console.log(UserTypeComments)

  const handleChangeTagUsers = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setselectedTagUsers(selectedOptions);
    // setselectedPersona(selectedValues);
    const userGroupsArray = selectedValues.map((value) => value);
    setTagUsersData(userGroupsArray);
    console.log(userGroupsArray);
  };

  const PostReplyTopic = () => {
    if (PostTopicReplayMessage === "") return false;
    setLoadingReplay(true);
    const email = localStorage.getItem("myemail");
    const data = {
      topicIdentifier: props.guid,
      email: email,
      subject: PostTopicReplayMessage,
      parentCommentId: parentId,
      topicId: topicid,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/createComment/v2`;
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          console.log(response);
          GetSaveReports();
          setopenReply(false);
          setLoadingReplay(false);
          setPostTopicReplayMessage("");
        }
      })
      .catch(function (error) {
        alert("Error");
        setLoadingReplay(false);
      });
  };

  const findUsernameFromGmail = (gmailAddress) => {
    const parts = gmailAddress.split("@");
    // console.log("parts:", parts); // Log the parts array
    if (parts.length === 2) {
      const usernameWithDot = parts[0]; // e.g., "nabasundar.rout"
      const usernameParts = usernameWithDot.split("."); // Split by dot
      if (usernameParts.length >= 1) {
        const username = usernameParts[0]; // Get the first part before the dot
        return username;
      }
    }
    return "Invalid Gmail address";
  };

  const EditPostTopic = (id, text) => {
    setEditPostId(id);
    setopenEditPost(!openEditPost);
    setPostTopicEditMessage(text);
  };

  const EditPostReplayTopic = (id, text) => {
    setEditPostReplyId(id);
    setopenEditReply(!openEditReply);
    setReplyTopicEditMessage(text);
  };

  const PostTopicEdit = () => {
    if (PostTopicEditMessage === "") return false;
    setLoadingReplay(true);
    const data = {
      topicIdentifier: props.guid,
      subject: PostTopicEditMessage,
      commentId: EditPostId,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/updateComment/v2`;
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          GetSaveReports();
          setopenEditPost(false);
          setLoadingReplay(false);
          setPostTopicEditMessage("");
        }
      })
      .catch(function (error) {
        console.log(error);
        alert("Error");
        setLoadingReplay(false);
      });
  };

  const PostReplyEdit = () => {
    if (ReplyTopicEditMessage === "") return false;
    setLoadingReplay(true);
    const data = {
      topicIdentifier: props.guid,
      subject: ReplyTopicEditMessage,
      commentId: EditPostReplyId,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/updateComment/v2`;
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          GetSaveReports();
          setopenEditReply(false);
          setLoadingReplay(false);
          setReplyTopicEditMessage("");
        }
      })
      .catch(function (error) {
        alert("Error");
        setLoadingReplay(false);
      });
  };

  const PostReplyDelete = () => {
    setLoadingReplay(true);

    const data = {
      topicIdentifier: props.guid,
      commentId: DeleteId,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/deleteComment/v2`;
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          console.log(response);
          GetSaveReports();
          setDeleteConfirm(false);
          setLoadingReplay(false);
        }
      })
      .catch(function (error) {
        alert("Error");
        setDeleteConfirm(false);
      });
  };

  const DeletePoup = (id) => {
    setDeleteId(id);
    setDeleteConfirm(!DeleteConfirm);
  };

  const ChangeTab = (data) => {
    setTabValue(data);
  };
  const [imagePreviews, setImagePreviews] = useState([]);

  const handlePaste = (e) => {
    const items = (e.clipboardData || e.originalEvent.clipboardData).items;

    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const blob = items[i].getAsFile();
        if (blob) {
          const reader = new FileReader();
          reader.onload = function (event) {
            const imagePreview = (
              <img
                style={{ width: "auto", maxWidth: "200px" }}
                src={event.target.result}
                alt="Pasted"
              />
            );
            setImagePreviews((prevPreviews) => [...prevPreviews, imagePreview]);
          };
          reader.readAsDataURL(blob);
        }
      }
    }
  };

  const toggleFaqsbtn = (index) => {
    const updatedOpenState = [...openState];
    updatedOpenState[index] = !updatedOpenState[index];
    setOpenState(updatedOpenState);
  };

  const convertToLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(
      urlRegex,
      (url) =>
        `<a class="faqslinks" href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
  };

  const notifications = () => {
    const x = document.getElementById("NotificationsIdValues");
    if (x.style.display === "") {
      $("#NotificationsIdValues").toggle(0);
      $("#main").css("marginRight", "400px");
    } else if (x.style.display === "none") {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", "400px");
    } else {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", "6px");
    }
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const commentId = searchParams.get("commentId");
  const replyId = searchParams.get("replyId");

  if (commentId !== null) {
    const toggleElement1 = document.getElementById(`postDataid_${commentId}`);

    if (toggleElement1 !== null) {
      $("#main").css("marginRight", "400px");
      $("#NotificationsIdValues").css("display", "block");
      $(`#postDataid_${commentId}`).css("display", "block");

      if (replyId !== null) {
        $(`#postDataid_${commentId}`).css("display", "block");
        $(`#nested-reply-${replyId}`).css("display", "block");
      }
    }
  }

  return (
    <>
      <div
        style={{
          height: "100%",
          position: "relative",
          background: `${tabValue === "tab2" ? "white" : ""}`,
        }}
      >
        <div id="chatRoomHeader">
          <div
            style={{
              height: "40px",
              backgroundColor: "#000",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              alignContent: "center",
              padding: "10px",
              paddingBottom: "14px",
            }}
          >
            <span>Comments & FAQ</span>
            <button id="refreshbutton" onClick={GetSaveReports}>
              {isrefreshing ? (
                <div className="clearfix">
                  <div
                    className="spinner-border spinner-border-sm float-right"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <RefreshIcon />
              )}
            </button>
          </div>
          {isrefreshing && (
            <div style={{ textAlign: "center" }}>Refreshing...</div>
          )}
          <div className="tabChatroom">
            <span
              id="tab1"
              onClick={() => ChangeTab("tab1")}
              className={`chatRoomTab ${
                tabValue === "tab1" ? "tabSelected" : ""
              }`}
            >
              Comments{" "}
              {postComments.length === 0 ? "" : `(${postComments.length})`}
            </span>

            <span
              id="tab2"
              onClick={() => ChangeTab("tab2")}
              className={`chatRoomTab ${
                tabValue === "tab2" ? "tabSelected" : ""
              }`}
            >
              FAQ
            </span>
          </div>
        </div>

        {tabValue === "tab1" && (
          <>
            {postComments.length === 0 && (
              <div className="noBookmark">
                <div>
                  <img width={150} src={bookmark} alt="bookmark" />
                </div>
                <div style={{ display: "grid", gridGap: "6px" }}>
                  <span
                    style={{
                      fontSize: "20px",
                      color: "gray",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    No Comments Available
                  </span>
                  <span
                    style={{
                      width: "80%",
                      display: "block",
                      margin: "auto",
                      color: "gray",
                      fontSize: "14px",
                    }}
                  >
                    {" "}
                    Your comments will help address any questions or concerns
                  </span>
                </div>
              </div>
            )}

            {postComments.length !== 0 && (
              <div style={{ paddingTop: "0px" }} className="postMainBody">
                {postComments.map((post, postindex) => {
                  return (
                    <div
                      id={`${`topic_id_${post.topicId}`}`}
                      key={postindex}
                      style={{
                        padding: "15px",
                        borderBottom: "5px solid #F1F3F8",
                        backgroundColor: "white",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          alignContent: "flex-start",
                          gridGap: "10px",
                        }}
                      >
                        <Avatar
                          style={{
                            width: "30px",
                            height: "30px",
                            fontSize: "10px",
                            textTransform: "uppercase",
                          }}
                        >
                          {post.author.charAt(0)}
                        </Avatar>
                        <div style={{ display: "grid", width: "100%" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                color: "#253978",
                                textTransform: "capitalize",
                              }}
                            >
                              {findUsernameFromGmail(post.author)}
                            </span>

                            {(post.author === email ||
                              typeofuser === "Admin") && (
                              <div style={{ display: "flex", gridGap: "20px" }}>
                                {post.author === email &&
                                  typeofuser === "Admin" && (
                                    <div
                                      style={{
                                        display: "flex",
                                        gridGap: "20px",
                                      }}
                                    >
                                      <FaEdit
                                        onClick={(e) =>
                                          EditPostTopic(
                                            post.commentId,
                                            post.text
                                          )
                                        }
                                        style={{
                                          color: "#253978",
                                          fontSize: "12px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                  )}

                                {typeofuser === "Admin" && (
                                  <div
                                    style={{ display: "flex", gridGap: "20px" }}
                                  >
                                    <FaTrash
                                      onClick={(e) =>
                                        DeletePoup(post.commentId)
                                      }
                                      style={{
                                        color: "#dc3545",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <span
                            style={{
                              fontSize: "14px",
                              color: "#253978",
                              fontWeight: "500",
                              wordBreak: "break-word",
                              display: "flex",
                              flexWrap: "wrap",
                              gridGap: "5px",
                            }}
                          >
                            <HighLighter text={post.taggedUsers} />

                            <span> {post.text}</span>
                          </span>

                          <span
                            style={{
                              fontSize: "12px",
                              paddingTop: "5px",
                              color: "#253978",
                            }}
                          >
                            Posted on: {formatDate(post.createdDateTime)}
                          </span>

                          <div
                            style={{
                              display: "flex",
                              gridGap: "1rem",
                              paddingTop: "1rem",
                              color: "#253978",
                              fontWeight: "600",
                              fontSize: "14px",
                            }}
                          >
                            <span
                              className="replyPost"
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                repliesComment(
                                  post.commentId,
                                  post.author,
                                  post.topicId
                                )
                              }
                            >
                              Reply
                            </span>

                            {post.replies.length !== 0 && (
                              <span
                                className="replyPost"
                                id={`postView_${post.topicId}`}
                                style={{ cursor: "pointer" }}
                                onClick={(e) => ViewMainPostReply(post.topicId)}
                              >
                                {postView[post.topicId]
                                  ? "Hide"
                                  : `Comments (${post.replies.length})`}
                              </span>
                            )}
                          </div>
                        </div>
                      </span>

                      {/* Render replies using the RenderReplies component */}
                      <div
                        id={`postDataid_${post.topicId}`}
                        className={postView[post.topicId] ? "" : "hideView"}
                        style={{
                          width: "100%",
                          paddingTop: "0rem",
                        }}
                      >
                        <RenderReplies
                          id={`postDataid_${post.topicId}`}
                          replies={post.replies}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}

        {tabValue === "tab2" && (
          <div style={{ background: "white" }}>
            {FaqsList.length === 0 && (
              <div className="noBookmark">
                <div>
                  <img width={150} src={bookmark} alt="bookmark" />
                </div>
                <div style={{ display: "grid", gridGap: "6px" }}>
                  <span
                    style={{
                      fontSize: "20px",
                      color: "gray",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    FAQ Not Found
                  </span>
                  <span
                    style={{
                      width: "80%",
                      display: "block",
                      margin: "auto",
                      color: "gray",
                      fontSize: "14px",
                    }}
                  >
                    {" "}
                    There is no FAQ available for this topic at the moment.
                  </span>
                </div>
              </div>
            )}

            {FaqsList.length !== 0 && (
              <div className="faqSections">
                {FaqsList.map((Items, index) => {
                  return (
                    <div
                      className={
                        openState[index]
                          ? "questionsMain active"
                          : "questionsMain"
                      }
                      key={index}
                    >
                      <div className="questions">
                        <div className="questions1">
                          <span>{Items.question}</span>
                        </div>

                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleFaqsbtn(index)}
                        >
                          {openState[index] ? <FaMinus /> : <FaPlus />}
                        </span>
                      </div>

                      <div
                        id={`collapseAnswer_${index}`}
                        className="faqsAns"
                        style={{ display: openState[index] ? "block" : "none" }}
                        dangerouslySetInnerHTML={{
                          __html: convertToLinks(Items.answer),
                        }}
                      >
                        {/* {Items.answer} */}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>

      <Dialog
        id="postNewCommentIdDiv"
        open={open}
        onClose={(e) => setOpen(!open)}
      >
        <div id="postDivRelative">
          <DialogTitle>Post Your Comment</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gridGap: "2rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gridGap: "10px",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <Avatar>N</Avatar>
                  <div style={{ display: "grid" }}>
                    <span> {userInfo?.given_name}</span>
                    <span style={{ fontSize: "14px" }}>{userInfo?.email}</span>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gridGap: "10px",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <FaUsers style={{ fontSize: "22px", color: "#0000a0" }} />
                  <Select
                    options={TagPeople}
                    required
                    placeholder="Select Types"
                    className="tagPeoples"
                    value={UserTypeComments}
                    onChange={(selectedOption) =>
                      setUserTypeComments(selectedOption)
                    }
                  />
                </div>
              </div>

              <div>
                {UserTypeComments.value === "Users" && (
                  <>
                    {userlistData.length === 0 && (
                      <>
                        <Select
                          options={userlistDataEmpty}
                          isMulti
                          required
                          placeholder="Select Users"
                          className="tagusers"
                          value={selectedTagUsers}
                          onChange={handleChangeTagUsers}
                        />
                      </>
                    )}

                    {userlistData.length !== 0 && (
                      <>
                        <Select
                          options={userlistData}
                          isMulti
                          required
                          placeholder="Select Users"
                          className="tagusers"
                          value={selectedTagUsers}
                          onChange={handleChangeTagUsers}
                        />
                      </>
                    )}
                  </>
                )}
              </div>
            </DialogContentText>

            {/* <div
              style={{
                display: "grid",
                gridGap: "10px",
                gridTemplateColumns: "48% 48%",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              {imagePreviews.map((image, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      display: "inline-block",
                      marginRight: "5px",
                      position: "relative",
                    }}
                  >
                    {image}
                    <div
                      style={{
                        position: "absolute",
                        color: "red",
                        top: "0",
                        left: "5px",
                      }}
                      onClick={() => removeImage(index)}
                    >
                      <FaTrash
                        style={{ fontSize: "12px", cursor: "pointer" }}
                      />
                    </div>
                  </div>
                );
              })}
            </div> */}

            <div
              style={{
                display: "grid",
                gridGap: "8px",
                justifyContent: "start",
                marginTop: "10px",
                gridTemplateColumns: "49% 49%",
              }}
            >
              {/* {pdfPreviews.map((preview, index) => {
                return (
                  <div style={{ position: "relative" }} key={index}>
                    <span>{preview}</span>
                    <span
                      style={{ position: "absolute", top: "0", right: "5px" }}
                      onClick={() => removePdf(index)}
                    >
                      <FaTrash
                        className="docdelete"
                        color="#f40f02"
                        fontSize={10}
                        style={{ cursor: "pointer" }}
                      />
                    </span>
                  </div>
                );
              })}

              {docPreviews.map((preview, index) => {
                return (
                  <div style={{ position: "relative" }} key={index}>
                    <span>{preview}</span>
                    <span
                      style={{ position: "absolute", top: "0", right: "5px" }}
                      onClick={() => removeDoc(index)}
                    >
                      <FaTrash
                        className="docdelete"
                        color="#f40f02"
                        fontSize={10}
                        style={{ cursor: "pointer" }}
                      />
                    </span>
                  </div>
                );
              })} */}
            </div>

            <TextareaAutosize
              value={PostTopicMessage}
              onChange={(e) => setPostTopicMessage(e.target.value)}
              onPaste={handlePaste}
              inputRef={inputRef} // Assign the inputRef to the TextareaAutosize
              minRows={3} // Adjust minRows as needed
              maxRows={5} // Adjust maxRows as needed
              placeholder={`Comment as ${userInfo?.given_name}`}
              style={{
                width: "100%",
                height: "auto",
                minHeight: "150px",
                border: "1px solid #cccccc",
                padding: "10px",
                borderRadius: "6px",
                marginTop: "0px",
                minWidth: "450px",
                maxWidth: "750px",
                resize: "none",
              }}
            />

            {/* <Button className="fileUploadComments" onClick={openFileInput}>
              <AttachmentIcon
                sx={{ color: "#0000a0" }}
                titleAccess="Attach File"
              />
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileSelection}
              style={{ display: "none" }}
              accept=".png, .jpg, .jpeg, .svg, image/png, image/jpeg, image/svg+xml, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            /> */}
          </DialogContent>

          <DialogActions id="postCommentActions">
            <Button className="submit_btn postcls" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              className="submit_btn postcls"
              disabled={LoadingReplay}
              onClick={PostTopic}
            >
              {LoadingReplay ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span style={{ paddingLeft: "10px" }}>Posting...</span>
                </>
              ) : (
                "Post"
              )}
            </Button>
          </DialogActions>
        </div>
      </Dialog>

      <Dialog open={openReply} onClose={(e) => setopenReply(!openReply)}>
        <DialogTitle>
          Reply to{" "}
          <span style={{ textTransform: "capitalize" }}>
            {findUsernameFromGmail(name)}
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Avatar>N</Avatar>
              <div style={{ display: "grid" }}>
                <span> {userInfo?.given_name}</span>
                <span style={{ fontSize: "14px" }}>{userInfo?.email}</span>
              </div>
            </div>
          </DialogContentText>
          <TextareaAutosize
            value={PostTopicReplayMessage}
            onChange={(e) => setPostTopicReplayMessage(e.target.value)}
            style={{
              width: "100%",
              height: "auto",
              minHeight: "150px",
              border: "2px solid #eee",
              padding: "10px",
              borderRadius: "6px",
              marginTop: "10px",
              minWidth: "400px",
              maxWidth: "400px",
              resize: "none",
            }}
            placeholder="Type your comments"
          />
        </DialogContent>
        <DialogActions id="postCommentActions">
          <Button className="submit_btn postcls" onClick={handleCloseReplay}>
            Cancel
          </Button>
          <Button
            className="submit_btn postcls"
            disabled={LoadingReplay}
            onClick={PostReplyTopic}
          >
            {LoadingReplay ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Replying...</span>
              </>
            ) : (
              "Reply"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditPost}
        onClose={(e) => setopenEditPost(!openEditPost)}
      >
        <DialogTitle>Edit Your Post Comment </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Avatar>N</Avatar>
              <div style={{ display: "grid" }}>
                <span> {userInfo?.given_name}</span>
                <span style={{ fontSize: "14px" }}>{userInfo?.email}</span>
              </div>
            </div>
          </DialogContentText>
          <TextareaAutosize
            value={PostTopicEditMessage}
            onChange={(e) => setPostTopicEditMessage(e.target.value)}
            style={{
              width: "100%",
              height: "auto",
              minHeight: "150px",
              border: "2px solid #eee",
              padding: "10px",
              borderRadius: "6px",
              marginTop: "10px",
              minWidth: "400px",
              maxWidth: "400px",
              resize: "none",
            }}
            placeholder="Type your comments"
          />
        </DialogContent>

        <DialogActions id="postCommentActions">
          <Button className="submit_btn postcls" onClick={handleClosePostEdit}>
            Cancel
          </Button>
          <Button
            className="submit_btn postcls"
            disabled={LoadingReplay}
            onClick={PostTopicEdit}
          >
            {LoadingReplay ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Updating...</span>
              </>
            ) : (
              "Update"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditReply}
        onClose={(e) => setopenEditReply(!openEditReply)}
      >
        <DialogTitle>Edit Your Comment </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Avatar>N</Avatar>
              <div style={{ display: "grid" }}>
                <span> {userInfo?.given_name}</span>
                <span style={{ fontSize: "14px" }}>{userInfo?.email}</span>
              </div>
            </div>
          </DialogContentText>
          <TextareaAutosize
            value={ReplyTopicEditMessage}
            onChange={(e) => setReplyTopicEditMessage(e.target.value)}
            style={{
              width: "100%",
              height: "auto",
              minHeight: "150px",
              border: "2px solid #eee",
              padding: "10px",
              borderRadius: "6px",
              marginTop: "10px",
              minWidth: "400px",
              maxWidth: "400px",
              resize: "none",
            }}
            placeholder="Type your comments"
          />
        </DialogContent>
        <DialogActions id="postCommentActions">
          <Button className="submit_btn postcls" onClick={handleCloseReplyEdit}>
            Cancel
          </Button>
          <Button
            className="submit_btn postcls"
            disabled={LoadingReplay}
            onClick={PostReplyEdit}
          >
            {LoadingReplay ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Updating...</span>
              </>
            ) : (
              "Update"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={DeleteConfirm}
        onClose={() => setDeleteConfirm(!DeleteConfirm)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete the conversation?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This action is irreversible and will remove all messages and history
            associated with this conversation.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="submit_btn"
            style={{ width: "auto", color: "white", borderRadius: "6px" }}
            onClick={PostReplyDelete}
            disabled={LoadingReplay}
          >
            {LoadingReplay ? (
              <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Removing...</span>
              </div>
            ) : (
              "Yes"
            )}
          </Button>

          <Button
            className="submit_btn"
            style={{ width: "auto", color: "white", borderRadius: "6px" }}
            onClick={() => setDeleteConfirm(!DeleteConfirm)}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {tabValue === "tab1" && (
        <Fab
          onClick={() => setOpen(!open)}
          className="floatingAddcomments"
          size="small"
          color="secondary"
          aria-label="add"
        >
          <AddIcon />
        </Fab>
      )}
    </>
  );
};

export default SlidingPanel;
